import styled from "@emotion/styled"
import { gridGap, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { useIntl } from "react-intl"
import { Grid, GridItem, Input, MultiSelect, Skeleton } from "src/components"
import { selectCatalogInteriorMessages } from "./selectCatalogInterior.messages"

export const SelectCatalogInteriorSkeleton = () => {
	const { formatMessage } = useIntl()

	return (
		<>
			<StyledGrid $rowGap={gridGap}>
				<GridItem size={{ base: 12, s: 4 }}>
					<MultiSelect
						name="tag"
						options={[]}
						label={formatMessage(selectCatalogInteriorMessages.tag)}
						disabled
					/>
				</GridItem>
				<GridItem size={{ base: 12, s: 4 }}>
					<MultiSelect
						name="material"
						options={[]}
						label={formatMessage(selectCatalogInteriorMessages.material)}
						disabled
					/>
				</GridItem>
				<GridItem size={{ base: 12, s: 4 }}>
					<Input name="searchText" type="search" disabled />
				</GridItem>
			</StyledGrid>
			<Skeleton.Table
				caption="Select Catalog Interior List"
				headings={[selectCatalogInteriorMessages.name, selectCatalogInteriorMessages.code]}
				rows={6}
			/>
		</>
	)
}

const StyledGrid = styled(Grid)`
	align-items: flex-end;
	margin-bottom: ${spacingStaticMd};
`
